var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.validIcon)?_c('div',{staticClass:"faction-icon",style:(_vm.offsetStyle),attrs:{"title":_vm.icon.name}}):_c('div',{staticClass:"faction-icon"})
}
var staticRenderFns = []

export { render, staticRenderFns }